export const NOT_AVAILABLE = "n/a";

//No Page found
export const NO_PAGE_FOUND_TITLE = "404 Page Not Found"
export const NO_PAGE_FOUND_DESC = " This page does not exist."

//Constants for Pagination
export const MAX_RESULT_PER_PAGE = 20;
export const MAX_VISIBLE_PAGES = 5;

//Criteria status
export const STATUS_ACTIVE = "ACTIVE";
export const STATUS_INACTIVE = "INACTIVE";

export const LIKERT_SCALE_LIST = [
    {name: "Needs Improvement", selected: 1},
    {name: "Marginal", selected: 2},
    {name: "Satisfactory", selected: 3},
    {name: "Good", selected: 4},
    {name: "Excellent", selected: 5}
];

export const LIKERT_SCALE_LIST_2 = [
    {name: "Needs Improvement", selected: 1},
    {name: "Excellent", selected: 2}
];

export const LIKERT_SCALE_LIST_3 = [
    {name: "Needs Improvement", selected: 1},
    {name: "Satisfactory", selected: 2},
    {name: "Excellent", selected: 3}
];

export const LIKERT_SCALE_LIST_4 = [
    {name: "Needs Improvement", selected: 1},
    {name: "Marginal", selected: 2},
    {name: "Good", selected: 3},
    {name: "Excellent", selected: 4}
];

export const CREATE_CRITERIA_FORM_STATE = {
    responseType: "2",
    status: "Active",
    criteria: "",
    description: "",
    calculation: "",
    category: 0,
    subCategory: 0,
    ratings: [
        {level: 1, description: ""},
        {level: 2, description: ""},
        {level: 3, description: ""},
        {level: 4, description: ""},
        {level: 5, description: ""}],
    functionalAreas: [],
    subFunctionalAreas: [],
    stakeholders: [],
    ranges: [
        {id: 1, rangeMin: 0, rangeMax: 0, valueMin: 100000, valueMax: 100000, label: "Needs Improvement", order: 1},
        {id: 2, rangeMin: 100, rangeMax: 100, valueMin: 0, valueMax: 0, label: "Excellent", order: 2}
    ],
    custLikertRanges: [
        {id: 1, rangeMin: 0, pointsRange: 0, label: "Needs Improvement", order: 1},
        {id: 2, rangeMin: 100, pointsRange: 100, label: "Excellent", order: 2}
    ]
}
export const CREATE_CRITERIA_QUANTITATIVE_STATE = [
    {id: 1, rangeMin: 0, rangeMax: 0, valueMin: 100000, valueMax: 100000, label: "Needs Improvement", order: 1},
    {id: 2, rangeMin: 100, rangeMax: 100, valueMin: 0, valueMax: 0, label: "Excellent", order: 2}
]

export const CREATE_CRITERIA_CUSTOM_LIKERT_STATE = [
    {id: 1, pointsRange: 0, label: "Needs Improvement", order: 1},
    {id: 2, pointsRange: 100, label: "Excellent", order: 2}
]

export const CREATE_TEAM_SUPPLIER_STATE = {
    sbm: {
        userId: "",
        firstName: "",
        lastName: ""
    },
    sro: {
        userId: "",
        firstName: "",
        lastName: ""
    },
    commodityCode: "",
    commodityName: "",
    functionalAreaObject: {},
    functionalAreaType: "",
    subFunctionalAreaObject: {},
    supplierInd: "",
    supplierLocation:""
}

export const SUPPLIER_MAINT_INIT_STATE = {
    sbm: {
        userId: "",
        firstName: "",
        lastName: ""
    },
    sro: {
        userId: "",
        firstName: "",
        lastName: ""
    },
    commodityCode: "",
    commodityName: "",
    functionalAreaObject: {},
    functionalAreaType: "",
    supplierNumber: "",
    supplierName: "",
    subFunctionalAreaId: 0,
    supplierInd: "",
    ratingTeamInd: "",
    supplierGroupName: "",
    location: "",
    qualityPeerGroup: "",
    activeIndicator: ""
}

export const RESP_TYPE_OPTIONS = [
    {value: "1", label: "Yes/No"},
    {value: "2", label: "Likert Scale"},
    {value: "4", label: "Custom Likert"},
    {value: "3", label: "Quantitative"}
]

export const TEAM_LEAD_OPTIONS = [
    {value: "Y", label: "Yes"},
    {value: "N", label: "No"}
]

export const SELECT_TEAM_LEAD_TEXT = "Select Team Leader to Add to Campaign";
export const TEAM_LEAD_TEXT = "Team Leader";

//ADMINS
export const CRITERIA_CATALOG_ADMIN = "CRITERIA_CATALOG_ADMIN";
export const UPLOAD_DATA = "Upload Data";
export const UPLOAD_QUANTITATIVE_DATA = "Upload Quantitative Data";
export const LAST_UPLOADED_DATE = "Last Updated";
export const FILE_UPLOAD_TEXT_TITLE = " Select file to Upload";
export const DOWNLOAD_TEMPLATE = "Download Template";
export const NO_DATA = "No Data Available";

//Criteria Details labels
export const CATEGORY = "Category";
export const SUB_CATEGORY = "Sub-Category";
export const RESPONSE_TYPE = "Response Type";
export const CRITERIA = "Criteria";
export const FUNCTIONAL_AREAS = "Functional Areas";
export const SUB_FUNCTIONAL_AREAS = "Sub Functional Areas";
export const STAKEHOLDERS = "Stakeholders";
export const RATING_DESC = "Rating Description";

//Create Campaign labels
export const PERIOD_QUESTION = "What period do you want to solicit feedback for?";
export const CURRENT_AE_SUPPLIER_TITLE = "My Current AE supplier";
export const SUPPLIER_QUESTION = "Which Supplier do you want feedback about?";
export const RESPONSE_BY_QUESTION = "When do you want stakeholder responses by?";

//Stepper Steps
export const CAMPAIGN_STEPS = ['Period & Supplier', 'Criteria', 'Stakeholders', 'Review', 'Publish'];

export const ANNUAL_RATING_STEPS = ['Set Up', 'Questions', 'Review', 'Publish'];

// Title Text
export const TITLE_TEXT = "Subjective Feedback Request ";

//Feedback status
export const INCOMPLETE = "Incomplete";
export const COMPLETE = "Complete";

export const FEEDBACK_TYPE_OPTIONS = [
    {value: "Y", label: "Yes"},
    {value: "N", label: "No"}
]

//Submit Feedback
export const NO_CRITERIA_INFO = "No specific questions are asked of you for this category. You may still provide general comments below.";
export const NO_CRITERIA_VIEW_INFO = "No specific questions are asked of you for this category.";
export const NOT_APPLICABLE = "Not Applicable"

//Feedback Form State
export const FEEDBACK_FORM_STATE = {
    supplierName: "",
    supplierNumber: "",
    period: "",
    fiscalYear: "",
    responseType: "",
    responseStatus: "",
    ratingValue: "",
    declineReason: "",
    notApplicable: false
}

//Summary Form State
export const SUMMARY_FORM_STATE = {
    title: "",
    campaignId: "",
    supplierName: "",
    supplierNumber: "",
    period: "",
    fiscalYear: "",
    dueDate: "",
    daysPending: 0,
    requestedByName: "",
    requestedById: "",
    reminders: [],
    responses: "",
    generalComments: [],
    feedbackOpen: true,
}

export const SUPPLIER_STATE = {
    isSupplierConsistent: true,
    isSupplierGroup: false,
    parentName: "",
    supplierInd: "",
    functionalArea: {},
    subFunctionalAreaId: 0,
    suppliers: [],
    criteria: [],
    generalComments: [],
    supplierName: "",
    categoryComments: []
}

//Supplier Form variables

export const SET_UP_QBIC = "Set up in QBIC"
export const QUALITY_PEER_GROUP = "Quality Peer Group"
export const SBM = "Supplier Base Manager (SBM)"
export const SRO = "Supplier Relationship Manager (SRO)"
export const COMMODITY_CODE = "Commodity Code"
export const SUPPLIER_PROFILE_STATUS = "Supplier Profile Status"
export const SUPPLIER_AE_STATUS = "Supplier AE Status"
export const SUPPLIER_AE_GROUP_NAME = "AE Supplier Group Name"
export const AE_RATING_TEAM = "AE Rating Team Exists"
export const SUPPLIER = "Supplier"
export const SUPPLIER_LOCATION = "Location"
export const SELECT_SUPPLIER_ERROR_MSG = "Please Select Supplier"
export const FUNCTIONAL_AREA = "Functional Area"
export const SUB_FUNCTIONAL_AREA = "Sub Functional Area"

//Send Reminder

export const SEND_REMINDER_DESCRIPTION = "The following individuals have not responded yet and will be sent an email reminder to submit their feedback."

export const SUBJECTIVE_FEEDBACK_CAMPAIGNS_NAV_LIST = [
    {path: '/criteria-catalog', name: "Criteria Catalog"},
    {path: '/campaigns', name: "Campaigns"},
    {path: '/feedback', name: "Feedback Requested of Me"},
    {path: '/rating-teams', name: "Rating Team Maintenance"},
    {path: '/supplier-mnt', name: "Supplier Maintenance"}
]

//Ratings
export const NO_CAMPAIGN_SENT = "No Campaign Sent"
export const NO_RESPONSES = "No Responses"
export const NO_COMMENTS = "No comments provided"
export const AVERAGE = "Average"
export const NOT_INCLUDED_IN_CAMPAIGNS = "Not Included in Feedback Campaigns"
export const NOT_AE_SUPPLIER = "Supplier has not been rated in AE. Please choose another supplier."
export const NOT_IN_AE_SUPPLIER = "Supplier is not available in AE. Please choose another supplier."
export const NOT_IN_AE_SUPPLIER_PLURAL = "Suppliers are not available in AE. Please choose another supplier."
export const SUPPLIER_NOT_CONSISTENT = "Supplier is part of a supplier group and the Supplier Groups are not aligned.\n" +
    "Contact the AE Admins for assistance."
export const VIEW_PERFORMANCE_GRAPH = "View Performance Graph"
export const QBIC = "QPG"
export const QUARTILE = "Quartile"
export const COMMENT_VISIBLE_TITLE = "Comment Visible to Suppliers"
export const CHANGE_COMMENT_VISIBLE = "Change Comment Visibility for Suppliers"
export const ADD_COMMENT_TITLE = "Add a Comment"
export const EDIT_COMMENT = "Edit Comment"
export const MENU_ADD_COMMENT = "Add a Comment"
export const MENU_OVERRIDE = "Override Score"
export const MENU_EDIT_OVERRIDE = "Edit Override Score"
export const MENU_QUESTION_NA = "Make Question Not Applicable"
export const MENU_EDIT_QUESTION_NA = "Edit N/A Question Reason"
export const ADMIN = "Admin"

//Ratings Summary
export const NOT_YET_PUBLISHED = "Not Yet Published"
export const CAMPAIGNS_CARD_TITLE = "Feedback Campaigns & Contacts"
export const CAMPAIGNS_CARD_TITLE_SUPPLIER = "Contacts"
export const GRO_TITLE = "Global Relationship Owner"
export const SRO_TITLE = "Relationship Owner"
export const PAST_PERF_CARD_TITLE = "AE Rating Past Performance"
export const SPEND_ROLLING_CARD_TITLE = "Spend - Rolling 12"
export const SPEND_TO_DATE_TITLE = "Spend - Fiscal Year to Date"
export const SPECIAL_AWARDS = "Special Awards"
export const COMING_SOON = "Coming Soon"
export const SPEND_IN_MILLION = "Spend in million USD"
export const VIEW_RATINGS_LINK_TITLE = "View Legacy Ratings"
export const CURRENT_RATINGS = "Current Ratings"
export const CURRENT_RATINGS_DUE = "Ratings Due"
export const OVERALL_SCORE_OVERRIDE = "Overall Score Override"
export const OVERRIDE = "Override"
export const EDIT_OVERRIDE = "Edit Override"
export const SCORE_OVERRIDE = "Overridden Score"
export const PAST_PERFORMANCE_OVERVIEW = "Past Performance Overview"
export const VIEW_PAST_PERFORMANCE = "View Past Performance"

//Summary
export const MANAGE_STAKEHOLDERS_DESCRIPTION = "The following individuals have been requested to provide feedback, you may reopen submitted feedback."
export const MANAGE_STAKEHOLDERS_TEXT = "Manage Stakeholders"
export const MANAGE_STAKEHOLDERS_DELETE_TOOLTIP = "Feedback Request has been started and cannot be deleted."
export const MANAGE_STAKEHOLDERS_ALERT_TITLE = "Stakeholder changes will not automatically update the Ratings Team"
export const MANAGE_STAKEHOLDERS_ALERT_DESC = "If you would like to update the ratings team for future campaigns, please navigate to Ratings Team Maintenance"
export const MANAGE_SH_USER_ERROR = "User name, role, and unit are mandatory"
export const MANAGE_SH_FEEDBACK_USERS_ERROR = "already submitted the feedback. Please reselect"
export const INVALID_USERS_TXT = "Invalid UserId(s)"

//Home Edit

export const AE_SCHEDULE_EDIT = "AE Schedule (CURRENT CALENDAR)"
export const NEXT_RATINGS = "Next Ratings"
export const QUICKLINKS = "Quicklinks"
export const RATINGS_OPEN = "Ratings Open"
export const RATINGS_DUE = "Ratings Due"
export const RATINGS = "Ratings"
export const MID_YEAR = "Mid-Year"
export const YEAR_END = "Year-End"
export const INCREASE = "Increase"
export const DECREASE = "Decrease"
export const FINAL = "Final"
export const PROJECTED = "Projected"
export const ADD_QUICKLINK = "Add New Quicklink"
export const VIEW_CALENDAR = "View Calendar"
export const AE_CALENDAR_LINK = "AE Calendar Link"
export const ADD_COMMENT = "Add New Comment"
export const DELETE_COMMENT = "Delete Comment"
export const AE_ANNOUNCEMENTS_INTERNAL = "AE Announcements (INTERNAL)"
export const AE_ANNOUNCEMENTS_EXTERNAL = "AE Announcements (EXTERNAL)"
export const DATE_CHECK_ERROR = "Due Date must be greater than Open Date"
export const INTER_DATE_CHECK_ERROR = "Year-End Open Date must be greater than Mid-Year Due Date"
export const AE_SCHEDULE = "AE Schedule"
export const EDIT_PAGE = "Edit Page"
export const AE_ANNOUNCEMENTS = "AE Announcements"
export const DUE_TOMORROW = "Due Tomorrow"
export const DUE_TODAY = "Due Today"
export const PAST_DUE = "Past Due"
export const NEW_AE_PROCESS_FILE_LINK = "AE Process Outline"
export const LEGACY_AE_DIRECT_LINK = "Legacy Direct: Reporting, DRWQ"
export const LEGACY_AE_INDIRECT_LINK = "Legacy Indirect: Past Performance"
export const LEGACY_AE_LOGISTICS_LINK = "Legacy Logistics: Past Performance"
export const RATINGS_PAGE_LINK = "Supplier Ratings"
export const AE_PROCESSING_CALENDAR_LINK = "AE Processing Calendar"
export const BEHAVIOR_MATRIX_LINK = "Behavior Matrix"
export const AE_BROCHURE_LINK = "AE Brochure"
export const JDCROP_LINK = "JDCROP"

//Override
export const OVERRIDDEN_SCORE = "Overridden Score"

//Not Applicable
export const QUESTION_NOT_APPLICABLE = "Question Not Applicable"

//Header
export const HOME = "Home"
export const CRITERIA_CATALOG = "Criteria Catalog"
export const CAMPAIGNS = "Campaigns"
export const FEEDBACK_REQUESTED = "Feedback Requested Of Me"
export const RATING_TEAMS = "Rating Team Maintenance"
export const GROUP_MAINT = "AE Group Maintenance"
export const SUPPLIER_MAINT = "Supplier Maintenance"
export const SUPPLIER_RATINGS = "Supplier Ratings"
export const RATING_PROGRAMS = "Rating Programs"

// Potential Team Members Constants
export const POTENTIAL_MEMBERS_TAB = "Potential New Members"
export const CURRENT_TEAMS_TAB = "Current Teams"
export const ADD_TO_TEAM = "Add to Team"
export const POTENTIAL_MEMBERS_TITLE = "Potential Team Members"
export const POTENTIAL_MEMBERS_SUBTITLE = "Discover and add new members to your evaluation teams"
export const SEARCH_PLACEHOLDER = "Search by name, user ID, department, or role"
export const MEMBER_ADDED_SUCCESS = "Team member added successfully"
export const POTENTIAL_MEMBERS_ERROR = "Error fetching potential team members"
export const ADD_MEMBER_ERROR = "Error adding member to team"
export const AVAILABLE_TEAMS_ERROR = "Error fetching available teams"
